import { icons } from 'lucide-react';

/** Map renamed Lucide icon names to their current equivalents */
const LEGACY_NAMES: Record<string, string> = {
  BarChart3: 'ChartBar',
  BarChart2: 'ChartColumn',
  BarChart: 'ChartColumn',
  CheckCircle: 'CircleCheck',
  CheckCircle2: 'CircleCheck',
  XCircle: 'CircleX',
  AlertCircle: 'CircleAlert',
  AlertTriangle: 'TriangleAlert',
  HelpCircle: 'CircleQuestionMark',
  PlayCircle: 'CirclePlay',
  PauseCircle: 'CirclePause',
  StopCircle: 'CircleStop',
  MinusCircle: 'CircleMinus',
  PlusCircle: 'CirclePlus',
  ArrowLeftCircle: 'CircleArrowLeft',
  ArrowRightCircle: 'CircleArrowRight',
  Loader2: 'LoaderCircle',
  Edit: 'SquarePen',
  Edit2: 'Pencil',
  Edit3: 'PenLine',
  Trash2: 'Trash',
  Wand2: 'Wand',
  CheckSquare: 'SquareCheck',
  CheckSquare2: 'SquareCheck',
  XSquare: 'SquareX',
  PlusSquare: 'SquarePlus',
  MinusSquare: 'SquareMinus',
};

/** Convert kebab-case (e.g. "user-plus") or any case to PascalCase (e.g. "UserPlus"). */
function toPascal(name: string): string {
  if (!name) return name;
  // Already PascalCase: starts with uppercase and contains no separators
  if (/^[A-Z][A-Za-z0-9]*$/.test(name)) return name;
  return name
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join('');
}

/** Render a Lucide icon by name, with emoji fallback for legacy data. */
export function LucideIcon({
  name,
  size = 24,
  className,
  style,
}: {
  name: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const pascal = toPascal(name);
  const resolved = LEGACY_NAMES[pascal] || pascal;
  const Icon = icons[resolved as keyof typeof icons];
  if (Icon) return <Icon size={size} className={className} style={style} />;
  // Fallback: render as text (emoji or raw string)
  return <span className={className} style={{ fontSize: size, ...style }}>{name}</span>;
}
